import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { applyPageMeta, resetPageMeta } from '../lib/pageMeta';

const widerrufHtml = `
<h2>Widerrufsrecht für Verbraucher</h2>
<p><em>Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können.</em></p>
<p>Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt 14 Tage ab dem Tag des Vertragsabschlusses.</p>
<p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Matthias Donner Consulting, Fürstenfeldbrucker Str. 14, 82272 Moorenweis, E-Mail: team@matthiasdonner.com) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.</p>
<p>Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.</p>

<h2>Folgen des Widerrufs</h2>
<p>Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.</p>

<h2>Muster-Widerrufsformular</h2>
<p>Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.</p>
<p>An</p>
<p>Matthias Donner Consulting<br />
Fürstenfeldbrucker Str. 14<br />
82272 Moorenweis<br />
E-Mail: team@matthiasdonner.com</p>
<p>Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über die Bereitstellung des Zugangs zu folgenden digitalen Inhalten (Bezeichnung, ggf. Bestellnummer und Preis):</p>
<p>..............................................................................</p>
<p>..............................................................................</p>
<p>Bestellt am (Datum):</p>
<p>.............................</p>
<p>Erhalten am (Datum):</p>
<p>.............................</p>
<p>Name und Anschrift des Verbrauchers:</p>
<p>.............................</p>
<p>.............................</p>
<p>.............................</p>
<p>.............................</p>
<p>Datum:</p>
<p>....................................................</p>
<p>Unterschrift Kunde (nur bei schriftlichem Widerruf):</p>
<p>....................................................</p>
`;

export default function WiderrufPage() {
  useEffect(() => {
    applyPageMeta({
      title: 'Widerrufsbelehrung',
      description: 'Widerrufsrecht, Fristen, Folgen des Widerrufs und Muster-Widerrufsformular für Verträge über die Nutzung von DSGVOeasy.',
      path: '/widerruf',
    });

    return resetPageMeta;
  }, []);

  return (
    <div style={{ fontFamily: "'72', '72full', Arial, Helvetica, sans-serif", color: '#32363a', minHeight: '100vh', background: '#f6f8fb' }}>
      {/* Nav */}
      <nav style={{
        background: 'white',
        borderBottom: '1px solid #e5e5e5',
      }}>
        <div className="legal-nav-inner" style={{
          maxWidth: '800px',
          margin: '0 auto',
          padding: '0 2rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '3.5rem',
        }}>
          <Link to="/login" style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', textDecoration: 'none' }}>
            <img src="/logo.png" alt="DSGVOeasy" style={{ height: '2rem', width: 'auto' }} />
            <span style={{ fontWeight: 700, fontSize: '1.125rem', color: '#1a1d21' }}>DSGVOeasy</span>
          </Link>
          <div className="legal-nav-links" style={{ display: 'flex', gap: '1.5rem' }}>
            <Link to="/datenschutz" style={{ color: '#556170', fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}>Datenschutz</Link>
            <Link to="/impressum" style={{ color: '#556170', fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}>Impressum</Link>
            <Link to="/login" style={{ color: '#0070f2', fontWeight: 600, fontSize: '0.875rem', textDecoration: 'none' }}>Zurück</Link>
          </div>
        </div>
      </nav>

      <div className="legal-container" style={{ maxWidth: '860px', margin: '0 auto', padding: '3rem 2rem 5rem' }}>
        <div className="legal-card" style={{
          background: 'white',
          borderRadius: '1rem',
          padding: '3rem',
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          border: '1px solid #edf0f4',
          lineHeight: 1.7,
          fontSize: '0.9375rem',
        }}>
          <style>{`
            .widerruf-content h2 {
              font-size: 1.125rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 0.5rem;
              color: #1a1d21;
            }
            .widerruf-content p {
              margin: 0 0 0.75rem;
            }
          `}</style>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '2rem', color: '#1a1d21' }}>Widerrufsbelehrung</h1>
          <div className="widerruf-content" dangerouslySetInnerHTML={{ __html: widerrufHtml }} />
        </div>
      </div>
    </div>
  );
}
